export default __webpack_public_path__ + "static/media/dupla_steak_grillezett zoldsegekkel.50427df1.jpg";